<template>
  <div class="ride main">
    <MainBackButton :forceHome="true" />

    <div v-if="selected">
      <RidePrivateMap
        v-if="isPrivate"
        :workflow="selected"
        :key="mapKey"
        @interact="mapInteract"
      />
      <RidePublicMap v-else :workflow="selected" :key="mapKey" />
    </div>
    <div v-else>
      <RideBlankMap />
    </div>

    <RideSelectPanel :transport="transport" @select="select" />
  </div>
</template>

<script>
import EventBus from "../eventBus";
import { sounds } from "../functions.js";
import geo from "@/geo";

import MainBackButton from "@/components/MainBackButton";
import RideBlankMap from "@/components/RideBlankMap";
import RidePrivateMap from "@/components/RidePrivateMap";
import RidePublicMap from "@/components/RidePublicMap";
import RideSelectPanel from "@/components/RideSelectPanel.vue";

export default {
  name: "Ride",
  components: {
    MainBackButton,
    RideBlankMap,
    RidePrivateMap,
    RidePublicMap,
    RideSelectPanel,
  },
  data() {
    return {
      selected: null,
    };
  },
  computed: {
    transport() {
      return this.$store.state.transport;
    },
    isPrivate() {
      if (!this.selected) return false;
      return this.selected.workflow_type_name === "Private Tuk Tuk";
    },
    mapKey() {
      if (!this.selected) return null;
      return this.selected.id;
    },
  },
  mounted() {
    // this.$store.commit("selectDriver", null); // turn off dispatch mode
    this.updateTransactionsForCustomer();
    this.updateLocation();
    this.checkVersion(); // check app version
    this.checkGeolocation(true);
    setInterval(() => this.checkGeolocation(false), 1000 * 10); // ask for geolocation
    // this.subscribeToStore();
    this.onVisibilityChange();
    // this.refreshTransport(); // update transport workflow?
  },
  activated() {
    // this.updateTransport();
    this.updateUserStops();
    this.updateLocation();
    this.showETA = true;
    this.city = geo.getRegion(this.$store.state.userState); // Chiang Mai, Bangkok, etc.
    this.$store.commit("setRegion", this.city); // should do this on every page
    this.$store.dispatch("getRideCount"); // update ride count

    this.forceRegion = false;
    this.checkLangQuery(); // prefix e.tuk or query lang=en
    var query = this.$route.query; // look for s for search
    if (query.r) {
      this.forceRegion = true; // force region if passed in query
      if (query.r === "cm") this.chooseCity("Chiang Mai"); // set region
      if (query.r === "bk") this.chooseCity("Bangkok"); // set region
      if (query.r === "sg") this.chooseCity("Singapore"); // set region
      if (query.r === "lb") this.chooseCity("Lisbon");
    }
    if (query.promo) {
      var blue = this.bulmaColor("info");
      if (query.promo === "free") {
        this.$swal({
          title: `<i class='fa fa-gift' style='color:${blue}'></i>`,
          html: `<div style='text-align:left; font-size:1.1em'>
          ${this.$t("promos.free4-info")}</div>`,
          showCloseButton: true,
          showCancelButton: false,
          confirmButtonColor: blue,
          confirmButtonText: this.$t("okay"),
        });
      }
      if (query.promo === "delivery") {
        this.$swal({
          title: `<i class='fa fa-gift' style='color:${blue}'></i>&nbsp;&nbsp;<i class='fa fa-shipping-fast'></i>`,
          html: `<div style='text-align:left; font-size:1.1em'>
          <p style='margin-bottom:12px'>${this.$t("promos.free4-info")}</p>
          <p><i>${this.$t("promos.delivery-info")}</i></p>
          </div>`,
          showCloseButton: true,
          showCancelButton: false,
          confirmButtonColor: blue,
          confirmButtonText: this.$t("okay"),
        });
      }
    }
    if (query.type === "send") {
      var p1 = `Choose vehicle type based on the size of the goods you are sending.`;
      var p2 = `Enter the <strong>phone number</strong> of the recipient in the notes.`;
      this.$swal({
        title: `<i class='fa fa-boxes'></i>&nbsp;&nbsp;<i class='fa fa-shipping-fast'></i>&nbsp;&nbsp;<i class='fa fa-motorcycle'></i>`,
        html: `<div style='text-align:left; font-size:1.1em'>
          <p style='margin-bottom:12px'>${p1}</p>
          <p>${p2}</p>
          </div>`,
        showCloseButton: true,
        showCancelButton: false,
        confirmButtonColor: blue,
        confirmButtonText: this.$t("okay"),
      });
    }
    this.$nextTick(() => this.updateTransport()); // gets nearby transport workflows/businesses
    // update yourPrivateTransport workflow/business as separate $store.dispatch
  },
  deactivated() {
    this.$notify({ group: "foo", clean: true });
  },
  beforeDestroy() {
    if (this.interval) clearInterval(this.interval); // not sure if needed
  },
  methods: {
    mapInteract() {
      // clearTimeout here
      // console.log("mapInteract");
    },
    chooseCity(city) {
      var coords = null; // could set default coords here
      switch (city) {
        case "Bangkok":
          coords = { lat: 13.7321, lon: 100.5696 };
          break;
        case "Chiang Mai":
          coords = { lat: 18.796143, lon: 98.979263 };
          break;
        case "Bagan":
          coords = { lat: 21.20129, lon: 94.908509 };
          break;
        case "Pakokku":
          coords = { lat: 21.33562, lon: 95.0171976 };
          break;
        case "Singapore":
          coords = { lat: 1.29027, lon: 103.851959 };
          break;
        case "Lisbon":
          coords = { lat: 38.71709, lon: -9.13926 };
          break;
      }
      this.$store.commit("setUserState", coords); // your fakeLocation
      this.$store.commit("setRegion", city);
    },
    select(selectedTransportWorkflow) {
      this.selected = selectedTransportWorkflow;
    },
    openDispatcherStats() {
      var r = this.$store.getters.getDispatcherRole;
      if (!r) alert("No dispatcher role");
      this.displayModal(".workflow-stats-modal");
      EventBus.$emit("WORKFLOW_STATS", r.workflow_id);
    },
    // maybe move to main.js or geo.js and call func getRegion()
    getNearestCity() {
      var userLoc = this.$store.state.userState; //this.$store.getters.getUserLocation;
      var chiangMai = { lat: 18.796143, lon: 98.979263 };
      var dist = geo.distanceToUserInMeters(chiangMai, userLoc);
      console.log("distance to Chiang Mai", `${dist / 1000}km`);
      if (dist / 1000 < 100) return "Chiang Mai"; // within 100km of CM
      return "Bangkok";
    },
    dispatchInfo() {
      var driverID = this.shortenString(this.$store.state.selectedDriver, 6);
      this.$swal({
        title: `<i class='fa fa-car' style='color:orange'></i>`,
        html: `Dispatching to driver: ${driverID}`,
        showCancelButton: true,
        showCloseButton: true,
        showConfirmButton: false,
        cancelButtonText: "Clear",
        cancelButtonColor: this.bulmaColor("danger"),
      }).then((val) => {
        console.log("val", val);
        if (val.dismiss === "cancel") {
          this.$store.commit("selectDriver", null);
          this.$toast.open("Dispatch mode OFF");
        }
      });
    },
    styleSelectedTitle() {
      if (!document.getElementById("selected-title")) return;
      if (!this.$store.state.selectedTransport) return;
      var w = this.$store.state.selectedTransport;
      this.loadingActiveDrivers = true;
      this.$store
        .dispatch("getWorkflowByID", w.id)
        .then((res) => {
          this.console("getWorkflowByID", res);
          this.$store.commit("updateSelectedTransport", res);
          if (!res.roles) return false;
          var activeDrivers = res.roles.filter((r) => r.state === "working");
          if (
            activeDrivers.length > 0 ||
            this.$store.state.selectedTransportType === "localtuk"
          )
            this.selectedHasActiveDrivers = true;
          else this.selectedHasActiveDrivers = false;
        })
        .catch((err) => this.apiError(err))
        .finally(() => (this.loadingActiveDrivers = false));
    },
    onVisibilityChange() {
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "hidden") return;
        this.updateTransactionsForCustomer(false); // needed to get any scheduled ride
        this.updateLocation();
      });
    },

    // duplicate of something in main.js?
    checkGeolocation(showPopup) {
      var options = { enableHighAccuracy: true, maximumAge: 1000 * 10 };
      this.$getLocation(options)
        .then((location) => {
          this.hasGeolocation = true;
          this.$store.commit("setUserState", {
            lat: location.lat,
            lon: location.lng,
            accuracy: location.accuracy,
          });
        })
        .catch((err) => {
          console.error("hasGeolocation error", err);
          this.hasGeolocation = false;
          if (!showPopup) return;
          if (this.$store.getters.getOS === "iOS") {
            EventBus.$emit("OPEN_IOS_GPS_MODAL");
            return;
          }
          if (this.$store.getters.getBrowser === "Chrome") {
            EventBus.$emit("OPEN_CHROME_GPS_MODAL");
            return;
          }
          this.$swal({
            type: "error",
            title: this.$t("gps.please-enable"),
            text: this.$t("gps.go-to-settings"),
          }).then((result) => {
            if (result.value) EventBus.$emit("OPEN_IOS_GPS_MODAL");
          });
        });
      this.$watchLocation(options).then((location) => {
        this.$store.commit("setUserState", {
          lat: location.lat,
          lon: location.lng,
          accuracy: location.accuracy,
        });
      });
    },

    resetMapObjects() {
      this.driverMarker = null;
      this.userMarker = null;
      this.passengerMarkers = [];
    },

    setupMapState() {
      if (this.interval) clearInterval(this.interval); // clear vehicle observer interval
      this.clearLayer(this.stateLayer);
      this.resetMapObjects();
      var state = this.$store.state.mapState;
      this.console("--- setupMapState --- setting up: ", state);
      if (state === "") this.setupMapStateNone();
      if (state === "passenger") this.setupMapStatePassenger();
      this.drawUserMarker(); // small marker to keep user location in stateLayer
      this.fitToLayer(this.stateLayer, 80);
    },
    setupMapStateNone() {
      if (this.interval) clearInterval(this.interval); // clear vehicle observer interval
      this.setupLocateControl(true);
      if (this.$store.state.selectedTransport) {
        this.drawTransportStops(this.$store.state.selectedTransport);
        // this.$store.commit("clearTimestamp", "trackTukTuk");
        this.showDriversForObserver(); // show all working drivers for workflow
        // this.pollDriversForObserver(); // polling the previous function, turn off for now
      } else {
        this.drawPrivateTukTuks();
      }
    },
    setupMapStatePassenger() {
      this.setupLocateControl(true);
      this.drawPassengerTransaction();
      // this.showDriversForObserver(); // show all working drivers for workflow
    },

    // subscribeToStore() {
    //   this.$store.subscribe((mutation) => {
    //     var mapMutations = ["selectTransport", "selectTukTuk", "clearTukTuk"];
    //     if (mapMutations.includes(mutation.type)) {
    //       this.setTransportIcon();
    //       this.styleSelectedTitle();
    //       this.console("--- mapStateMutation --- mutation", mutation.type);
    //       this.setupMapState();
    //     }
    //     // moved
    //     if (mutation.type === "setTransactionsForCustomer") {
    //       this.drawDriverForPassenger();
    //       this.updatePassengerTransaction();
    //     }
    //   });
    // },

    clearLayer(layer) {
      if (layer) layer.clearLayers();
    },
    /* toggle between flying to your location and fitting to stateLayer */
    locate() {
      this.pollLocation();
      if (this.zooming) return; // don't do anything if already zooming
      this.zooming = true;
      this.map.on("zoomend", () => (this.zooming = false));
      // this.map.on("moveend", () => (this.zooming = false)); // probably need this
      if (this.locateToggle) {
        this.console("flyTo userLocation");
        // distance check here should be current map center to userLocation!!!
        if (this.$store.state.userState.distance > 100) {
          this.map.setView(this.$store.getters.getUserLocation);
          this.zooming = false;
        } else {
          this.map.flyTo(this.$store.getters.getUserLocation);
        }
      } else {
        this.console("fit to state layer");
        this.fitToLayer(this.stateLayer);
      }
      this.locateToggle = !this.locateToggle; // toggle it
      setTimeout(() => this.map.invalidateSize(), 1000); // might help force redraw
    },

    /////////////////////////////////// The meaty bits ///////////////////////////////////////

    drawDriverForPassenger() {
      if (this.mapState !== "passenger") return;
      var t = this.$store.getters.getCustomerTransactions[0]; // shouldn't have more than 1
      if (!t) return;
      if (t.state === "initiated") {
        if (this.driverMarker) {
          // in case driver had cancelled and it went back into state initiated
          this.stateLayer.removeLayer(this.driverLine);
          this.stateLayer.removeLayer(this.driverMarker);
        }
        this.showDriversForObserver(); // show all working drivers for workflow
        return; // no driver at this state
      } else {
        this.removeDriversForObserver();
      }
      if (!t.driver) {
        console.error("No driver set on customer transaction!");
        return;
      }
      var ds = t.driver.user_state;
      this.console("drawDriverForPassenger", ds);
      if (ds.lat == 0) {
        console.warn("bad driver location!", ds);
        return;
      }
      if (!this.driverMarker) this.initialiseDriverForPassenger(ds);

      if (t.state === "enroute" && this.driverLine) {
        this.stateLayer.removeLayer(this.driverLine); // remove driver line
      }
      if (t.state === "alighted") return;
      this.driverMarker.slideTo([ds.lat, ds.lon], this.slideOpts);
      var profPic = this.profPic(t.driver);
      var img = `<img src=${profPic} height="150px" width="150px"/>`;
      var driver = this.$t("driver.driver");
      var content = `${img}<center><strong>${t.driver.name}</strong><br>${driver}</center>`;
      this.driverMarker.bindPopup(content, this.popupNarrow);
      if (t.state !== "enroute") {
        this.drawDriverToPickupLine();
      }
    },

    removeDriversForObserver() {
      if (this.driversMarkers && this.driversMarkers.length > 0) {
        this.driversMarkers.forEach((m) => this.stateLayer.removeLayer(m)); // first remove previous markers
      }
    },

    drawDriversForObserver(drivers) {
      if (!drivers || drivers.length === 0) return;
      this.removeDriversForObserver();
      var availableIcon = L.divIcon({
        html: `<div class='driver-circle available-bg'><img class='driver-small' src='${this.imgDefault}' /></div>`,
        popupAnchor: [-5, -20],
        className: "none",
      });
      var busyIcon = L.divIcon({
        html: `<div class='driver-circle busy-bg'><img class='driver-small' src='${this.imgDefault}' /></div>`,
        popupAnchor: [-5, -20],
        className: "none",
      });
      var available = { icon: availableIcon, draggable: true };
      var busy = { icon: busyIcon, draggable: true };

      drivers.forEach((ds) => {
        if (ds.id === this.$store.state.user.id) return; // skip yourself
        if (ds.role.role_name === "Dispatcher") return; // skip dispatcher
        if (ds.lat == 0) {
          console.warn("bad driver location!", ds);
          return;
        }
        if (this.farAwayFromUser(ds, 3000)) return;
        var t = (new Date() - new Date(ds.updated_at)) / (1000 * 60); // minutes ago
        if (t < 0) return 0;
        if (t > 240) return; // don't show if older than an hour or 4 hours
        var options = available;
        if (ds.role.data.is_busy) options = busy;
        var m = L.marker([ds.lat, ds.lon], options).addTo(this.stateLayer);
        var name = `<strong>${ds.user.name}</strong>`;
        var text = `${name}<br>${Math.round(t)} mins ago`;
        var content = `<a onclick="selectDriver('${ds.id}')">${text}</a>`;
        if (!this.isSuperUser()) content = `<a>${text}</a>`;
        m.bindPopup(content, this.popupNarrow);
        this.driversMarkers.push(m);
      });
    },

    showDriversForObserver() {
      if (!this.$store.state.selectedTransport) return;
      var workflowType = this.$store.state.selectedTransport.workflow_type_name;
      if (workflowType === "Sii Lor") {
        return this.showSiilorDriversForObserver();
      }
      if (workflowType === "Public Tuk Tuk") {
        return this.showNearbyDriversForObserver();
      }
      this.$store
        .dispatch("trackDrivers", this.$store.state.selectedTransport.id)
        .then((driverStates) => this.drawDriversForObserver(driverStates))
        .catch((err) => {
          if (!err) return;
          console.warn("trackDrivers", err.message, err.response);
          if (err.response) {
            if (err.response.data === "No active workers") {
              clearInterval(this.interval);
            }
          }
        });
    },

    showSiilorDriversForObserver() {
      this.$store
        .dispatch("trackSiilors")
        .then((driverStates) => this.drawDriversForObserver(driverStates))
        .catch((err) => {
          if (!err) return;
          console.warn("trackSiilors", err.message, err.response);
          if (err.response) {
            if (err.response.data === "No active workers") {
              clearInterval(this.interval);
            }
          }
        });
    },

    showNearbyDriversForObserver() {
      this.$store
        .dispatch("trackNearby", this.$store.state.selectedTransport.id)
        .then((driverStates) => this.drawDriversForObserver(driverStates))
        .catch((err) => {
          if (!err) return;
          console.warn("trackNearby", err.message, err.response);
          if (err.response) {
            if (err.response.data === "No active workers") {
              clearInterval(this.interval);
            }
          }
        });
    },

    updatePassengerTransaction() {
      var t = this.$store.getters.getCustomerTransactions[0];
      if (!t) return;
      if (t.state === "enroute" || t.state === "alighted") {
        this.$notify({
          group: "foo",
          clean: true,
        });
        if (!this.pickupMarker) return;
        if (!this.pickupMarker.userLine) return;
        this.stateLayer.removeLayer(this.pickupMarker.userLine);
      }
      if (t.data.type === "delivery") return; // these aren't for delivery txns
      if (t.state === "confirmed" && this.showConfirmed) {
        this.showConfirmed = false;
        sounds("safe");
        setTimeout(() => this.fitToLayer(this.stateLayer, 80), 500);
        this.$notify({
          group: "foo",
          title: this.$t("passenger.driver-on-the-way"), //"Driver is on the way!",
          text: `${this.$t("passenger.please-walk")} 🙏🏽`, // Please make your way to the pickup point
          duration: -1,
          ignoreDuplicates: true,
        });
        if (t.data.eta && this.showETA) {
          this.showETA = false;
          this.$notify({
            group: "foo",
            type: "warn",
            title: this.$t("passenger.eta-title", { eta: t.data.eta }), //"I'll be there in 5 minutes", // t.data.eta field is minutes
            text: this.$t("passenger.eta-text"), //`I'll send another message when I reach your location 💬`,
            duration: -1,
            ignoreDuplicates: true,
          });
        }
        if (t.data.scheduled_time) {
          var time = new Date(t.data.scheduled_time).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          });
          this.$notify({
            group: "foo",
            title: this.$t("passenger.scheduled-title", { time: time }), //"I'll be there in 5 minutes", // t.data.eta field is minutes
            text: this.$t("passenger.eta-text"), //`I'll send another message when I reach your location 💬`,
            duration: -1,
            ignoreDuplicates: true,
          });
        }
      }
      if (t.state === "driver_arrived") {
        this.showConfirmed = true; // reset for next trip
        this.$notify({
          group: "foo",
          type: "success",
          title: this.$t("passenger.driver-has-arrived"), //"Driver has arrived!",
          text: `${this.$t("passenger.please-walk")} 📍`,
          duration: -1,
          position: "top center",
          ignoreDuplicates: true,
        });
      }
      if (t.state === "cancelled_by_driver") {
        this.$notify({ group: "foo", clean: true });
        this.$notify({
          group: "foo",
          type: "error",
          title: this.$t("passenger.driver-cancelled"), //"Driver had to cancel!",
          text: this.$t("passenger.please-request-again"), //"Please request another ride or try again later 😕",
          duration: -1,
          position: "top center",
          ignoreDuplicates: true,
        });
      }
      if (t.state === "no_show") {
        this.$notify({ group: "foo", clean: true });
        this.$notify({
          group: "foo",
          type: "error",
          title: this.$t("passenger.no-show"), //"Driver had to cancel!",
          text: this.$t("passenger.please-request-again"), //"Please request another ride or try again later 😕",
          duration: -1,
          position: "top center",
          ignoreDuplicates: true,
        });
      }
    },

    drawPassengerTransaction() {
      var t = this.$store.getters.getCustomerTransactions[0];
      if (!t) return;
      var iconClass = "street-view";
      if (t.data.type === "delivery") iconClass = "store-alt";
      var pickupIcon = L.AwesomeMarkers.icon({
        icon: iconClass, //"arrow-up",
        markerColor: "blue",
        iconColor: "yellow",
      });
      var pickupCoords = [t.data.pickup_stop.lat, t.data.pickup_stop.lon];
      var icon = { icon: pickupIcon };
      var p = L.marker(pickupCoords, icon).addTo(this.stateLayer);
      this.pickupMarker = p;
      var pickupText = this.$t("transport.pickup-point");
      var text = `<strong>${t.data.pickup_stop.name}</strong><br>${pickupText}`;
      p.bindPopup(text, this.popupWide);

      if (t.data.dropoff_stop) {
        var dropoffIcon = L.AwesomeMarkers.icon({
          icon: "flag-checkered", //"arrow-down",
          markerColor: "lightgreen",
          iconColor: "blue",
          extraClasses: "fa-lg",
        });
        var dropoffCoords = [t.data.dropoff_stop.lat, t.data.dropoff_stop.lon];
        var icon = { icon: dropoffIcon };
        var d = L.marker(dropoffCoords, icon).addTo(this.stateLayer);
        this.dropoffMarker = d;
        var dropoffText = this.$t("transport.dropoff-point");
        var text = `<strong>${t.data.dropoff_stop.name}</strong><br>${dropoffText}`;
        d.bindPopup(text, this.popupWide);
      }

      // draw walking line for passenger
      var latlngs = Array();
      latlngs.push(this.$store.getters.getUserLocation);
      latlngs.push(p.getLatLng());
      var userLine = L.polyline(latlngs, this.dashLine).addTo(this.stateLayer);
      this.pickupMarker.userLine = userLine;
      userLine.pickupCoords = p.getLatLng();
      this.redrawLineForUser(userLine); // update walking line when user location changes
      this.redrawLineOnZoom(userLine);
    },

    redrawLineForUser(line) {
      this.map.on("locationfound", (e) => {
        var userLocation = e.latlng;
        line.setLatLngs([userLocation, line.pickupCoords]);
      });
    },

    drawDriverToPickupLine() {
      var latlngs = Array();
      if (!this.driverLine) {
        if (!(this.pickupMarker && this.driverMarker)) return;
        latlngs.push(this.pickupMarker.getLatLng());
        latlngs.push(this.driverMarker.getLatLng());
        this.driverLine = L.polyline(latlngs, {
          color: "yellow",
          weight: "2",
          dashArray: "5, 10",
        }).addTo(this.stateLayer);
        this.redrawLineOnZoom(this.driverLine);
      } else {
        latlngs.push(this.pickupMarker.getLatLng());
        latlngs.push(this.driverMarker.getLatLng());
        this.driverLine.setLatLngs(latlngs);
      }
    },

    drawPassengerToPickupLine(customerMarker) {
      var c = customerMarker;
      var stop = c.transaction.data.pickup_stop;
      var pickupCoords = [stop.lat, stop.lon];
      var latlngs = Array();
      // this.console("p2p", c.transaction, pickupCoords, c.getLatLng());
      if (!c.line) {
        latlngs.push(c.getLatLng());
        latlngs.push(pickupCoords);
        c.line = L.polyline(latlngs, this.dashLine).addTo(this.stateLayer);
        this.redrawLineOnZoom(c.line);
      } else {
        latlngs.push(c.getLatLng());
        latlngs.push(pickupCoords);
        c.line.setLatLngs(latlngs);
      }
    },

    drawPassengerPickupPoint(customerMarker) {
      var c = customerMarker;
      var s = c.transaction.data.pickup_stop;
      var pickupText = this.$t("transport.pickup-point");
      var text = `<strong>${s.name}</strong><br>${pickupText}`;
      var dot = L.divIcon({
        html: `<div class='pickup-point'></div>`, // yellow dot
        popupAnchor: [5, -10],
        className: "none",
      });
      var icon = { icon: dot };
      var pickup = L.marker([s.lat, s.lon], icon)
        .addTo(this.stateLayer)
        .bindPopup(text, this.popupWide);
      c.pickup = pickup;
    },

    drawPassengerDropoffPoint(customerMarker) {
      var c = customerMarker;
      if (!c.transaction.data.dropoff_stop) return;
      var s = c.transaction.data.dropoff_stop;
      var dropoffText = this.$t("transport.dropoff-point");
      var text = `<strong>${s.name}</strong><br>${dropoffText}`;
      var dot = L.divIcon({
        html: `<div class='dropoff-point'></div>`, // yellow dot
        popupAnchor: [5, -10],
        className: "none",
      });
      var icon = { icon: dot };
      var dropoff = L.marker([s.lat, s.lon], icon)
        .addTo(this.stateLayer)
        .bindPopup(text, this.popupWide);
      c.dropoff = dropoff;
    },

    coloredIcon(state) {
      var color = "blue";
      if (state === "initiated") color = "orange";
      if (state === "confirmed") color = "darkblue";
      if (state === "cancelled_by_passenger") color = "red";
      if (state === "driver_arrived") color = "green";
      // if (state === "enroute") color = "blue"; // default color?
      // this.console("coloredIcon", state, color);
      return L.AwesomeMarkers.icon({
        icon: "street-view",
        markerColor: color,
      });
    },

    driverRejected(t) {
      // if (this.$store.state.rejectedTransactions.find(rtID => t.id))
      if (this.$store.state.rejectedTransactions.find((rt) => rt === t.id))
        return true;
      return false;
    },

    drawPrivateTukTuks() {
      var privateTuks = this.$store.getters.getValidWorkflowsPrivateTuk;
      if (!privateTuks) return;
      var bldgIcon = L.AwesomeMarkers.icon({
        icon: "home",
        markerColor: "blue",
      });
      privateTuks.forEach((w) => {
        var b = L.marker([w.business.lat, w.business.lon], { icon: bldgIcon })
          .addTo(this.stateLayer)
          .bindPopup(w.business.name);
        b.workflow = w;
        b.on("click", (e) => {
          if (!this.loginOkay("Login to use Private Tuk Tuk")) return;
          var businessName = e.target.workflow.business.name;
          // this.$store.commit("selectTukTuk", e.target.workflow);
          // this.success(`${this.$t("transport.selected")} ${businessName}`);
          this.$swal({
            title: businessName,
            text: this.$t("transport.select-private-tuk"), //"Select this private tuk tuk?",
            showCancelButton: true,
            confirmButtonText: this.$t("confirm"),
            cancelButtonText: this.$t("cancel"),
          }).then((result) => {
            if (result.value) {
              this.$store.commit("selectTukTuk", e.target.workflow);
            }
          });
        });
      });
    },

    drawTransportStops(w) {
      this.console("draw transport stops", w);
      if (!w.data) return;
      var dot = L.divIcon({
        html: `<div class='purple-stop'></div>`,
        popupAnchor: [3, -6],
        className: "none",
      });
      var stops = w.data.stops;
      if (w.workflow_type_name === "Sii Lor") {
        stops = this.$store.getters.getSiilorStopsAll; // siilor show all stops
        dot = L.divIcon({
          html: `<div class='purple-stop siilor-stop'></div>`,
          popupAnchor: [0, -6],
          className: "none",
        });
      }
      if (w.workflow_type_name === "Songthaew") {
        stops = this.$store.getters.getSongthaewStopsAll; // siilor show all stops
        dot = L.divIcon({
          html: `<div class='purple-stop songthaew-stop'></div>`,
          popupAnchor: [0, -6],
          className: "none",
        });
      }
      if (w.workflow_type_name === "Public Tuk Tuk") {
        stops = this.$store.getters.getPublicTuktukStopsAll; // siilor show all stops
        dot = L.divIcon({
          html: `<div class='purple-stop publictuk-stop'></div>`,
          popupAnchor: [0, -6],
          className: "none",
        });
      }
      stops.forEach((s) => {
        if (this.farAwayFromUser(s, 1000)) return; // skip
        var text = `<i class="fa fa-map-marker-alt" style="font-size:1.3em; color:grey"></i>&nbsp;<span class="subtitle is-6">${s.name}</span>`;
        L.marker([s.lat, s.lon], { icon: dot })
          .addTo(this.stateLayer)
          .bindPopup(text, this.popupWide);
      });
    },

    farAwayFromUser(p, dist) {
      if (this.$store.getters.isSuperUser) return false; // show all drivers to superuser
      if (this.isDispatcher) return false; // show all drivers to dispatcher
      var coords = this.$store.getters.getUserLocation;
      if (!coords) return false;
      var userLoc = { lat: coords[0], lon: coords[1] };
      if (geo.distanceToUserInMeters(p, userLoc) > dist) return true;
      return false;
    },

    userIsFarAway() {
      var w = this.$store.state.selectedTransport;
      if (!w) return true;
      if (
        w.data.stops[0].distance > 1000 ||
        w.data.stops[0].distance == undefined
      ) {
        this.console(`FAR AWAY true: ${w.data.stops[0].distance}m`);
        return true; // if more than 1km from closest stop then isFarAway
      }
      // console.warn("stop distance", w.data.stops[0].distance);
      // this.console("FAR AWAY false");
      return false;
    },

    drawUserMarker() {
      if (!this.$store.getters.getUserLocation) {
        console.warn("drawUserMarker getters.getUserLocation null");
        return;
      }
      if (this.userIsFarAway()) return; // if user is far away don't draw
      var coords = this.$store.getters.getUserLocation;
      var opts = {
        radius: 10,
        stroke: false,
        fillColor: "#ffc0cb",
        fillOpacity: 0.3,
      };
      this.userMarker = L.circle(coords, opts).addTo(this.stateLayer); // draw tiny 1m circle
      var debug = JSON.stringify(this.$store.state.userState);
      this.userMarker.bindPopup(debug, this.popupWide);
      this.console("drawUserMarker", coords, this.userMarker);
      // alert("Added userMarker to stateLayer");
      this.map.on("locationfound", (e) => {
        if (!this.userMarker) return;
        this.userMarker.setLatLng(e.latlng);
        // could redraw walking line for passenger here?
      });
    },
  },
};
</script>

<style scoped>
.main {
  overflow: hidden;
  height: 100vh;
  width: 100vw;
}
</style>